import script from "./CustomerDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDetail.vue?vue&type=style&index=0&id=c711462c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c711462c"]])

export default __exports__